import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';

const DOMAIN_PATTERNS = {
  [SourceDomain.DociaDe]: [/(^|\.)docia\.de$/i, /^docia-[^.]+\.vercel\.app$/i],
  [SourceDomain.PflegiaDe]: [/(^|\.)pflegia\.de$/i, /^pflegia-[^.]+\.vercel\.app$/i],
  [SourceDomain.PraxiaDe]: [/(^|\.)praxia\.de$/i, /^praxia-[^.]+\.vercel\.app$/i],
} as const;

export const getSourceDomainFromHostname = (hostname: string) => {
  const lowerHostname = hostname.toLowerCase();

  // Check Docia patterns first (most specific brand)
  if (DOMAIN_PATTERNS[SourceDomain.DociaDe].some(pattern => pattern.test(lowerHostname))) {
    return SourceDomain.DociaDe;
  }

  // Check Praxia patterns next (more specific brand than Pflegia)
  if (DOMAIN_PATTERNS[SourceDomain.PraxiaDe].some(pattern => pattern.test(lowerHostname))) {
    return SourceDomain.PraxiaDe;
  }

  // Check Pflegia patterns
  if (DOMAIN_PATTERNS[SourceDomain.PflegiaDe].some(pattern => pattern.test(lowerHostname))) {
    return SourceDomain.PflegiaDe;
  }

  // Default for localhost and unknown domains
  return SourceDomain.PflegiaDe;
};

export default getSourceDomainFromHostname;
